import React, { createContext, useState, useContext, useCallback } from 'react';

// Crear el contexto
const SidebarContext = createContext();

// Proveedor del contexto
export const SidebarProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = useCallback(() => {
    setCollapsed(prevState => !prevState);
  }, []);

  const value = {
    collapsed,
    toggleCollapsed,
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};

// Hook personalizado para usar el contexto
export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar debe ser usado dentro de un SidebarProvider');
  }
  return context;
};
